var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 316.044,
    height: 229.074,
    viewBox: "0 0 316.044 229.074",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c,.e{fill:#bdbdbd;}.a{opacity:0.3;}.b{fill:#c9c9ca;}.c{opacity:0.6;}.d{fill:#eee;}.f{fill:url(#a);}.g{fill:#192b59;}.h{fill:url(#b);}.i{fill:#f2dad4;}.j{fill:url(#c);}.k{fill:url(#d);}.l{fill:url(#e);}.m{fill:url(#f);}.n{fill:url(#g);}.o{fill:url(#h);}.p{fill:url(#i);}.q{fill:url(#j);}.r{fill:url(#l);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: -0.227,
    x2: 0.5,
    y2: 0.559,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f8fa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.276,
    y1: -0.498,
    x2: 0.5,
    y2: 0.639,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbb78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8f21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.768,
    y1: 1.287,
    x2: 0.359,
    y2: 0.334,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d0633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#192b59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2bfad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2dad4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.265,
    y1: -0.23,
    x2: 0.691,
    y2: 0.944,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.303,
    y1: -0.385,
    x2: 0.526,
    y2: 0.648,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0.419,
    y1: -0.145,
    x2: 0.536,
    y2: 0.837,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 0.103,
    y1: -0.049,
    x2: 0.752,
    y2: 0.905,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.086,
    y1: 0.016,
    x2: 0.677,
    y2: 0.759,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 0.602,
    y1: 0.368,
    x2: 0.324,
    y2: 0.911,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 0.064,
    y1: -0.401,
    x2: 0.687,
    y2: 0.848,
    xlinkHref: "#b"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1131.343 -837.864)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.899, -0.438, 0.438, 0.899, 1210.515, 875.918)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 77.821,
    height: 77.821,
    rx: 12.45,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.9,4.9H5.672a1.224,1.224,0,0,1,0-2.448H19.138V1.224A1.224,1.224,0,0,0,17.914,0H4.448A2.448,2.448,0,0,0,2,2.448V22.034a2.455,2.455,0,0,0,2.448,2.448H19.138a2.448,2.448,0,0,0,2.448-2.448V6.121A1.224,1.224,0,0,0,20.362,4.9H11.793v9.793L9.345,12.241,6.9,14.689Z",
    transform: "translate(24.916 27.122)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1338.33 837.864) rotate(43)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 61.692,
    height: 61.692,
    rx: 12.45,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1.344,0A1.337,1.337,0,0,0,.013,1.344L0,20.167a1.34,1.34,0,0,0,1.344,1.344H14.789a1.348,1.348,0,0,0,1.344-1.344V6.722L9.411,0ZM9.411,6.722V1.344l5.378,5.378Z",
    transform: "translate(24.453 18.528)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1131.343 932.722)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1867.177,1022a2.2,2.2,0,0,0-4.339.679c.315,2.045.716,8.453-1.495,11.031a2.95,2.95,0,0,1-1.782,1.025l.2-12.2a3.174,3.174,0,1,0-6.347.026l.573,23.159a2.962,2.962,0,0,1-1.858-1.035c-2.211-2.578-1.81-8.986-1.495-11.031a2.2,2.2,0,0,0-4.339-.679c-.158,1.008-1.427,9.98,2.495,14.562a7.435,7.435,0,0,0,5.307,2.608l.25,10.08h4.792l.348-21.06a7.42,7.42,0,0,0,5.195-2.6C1868.6,1031.975,1867.334,1023,1867.177,1022Z",
    transform: "translate(-1588.845 -1019.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1217.906,1077.879a1.4,1.4,0,1,0-2.766.433c.2,1.3.457,5.388-.953,7.032a1.883,1.883,0,0,1-1.136.653l.128-7.78a2.024,2.024,0,1,0-4.046.017L1209.5,1093a1.888,1.888,0,0,1-1.184-.66c-1.409-1.644-1.154-5.728-.953-7.032a1.4,1.4,0,0,0-2.766-.432c-.1.643-.91,6.362,1.59,9.283a4.738,4.738,0,0,0,3.383,1.663l.159,6.426h3.054l.222-13.426a4.729,4.729,0,0,0,3.312-1.658C1218.816,1084.24,1218.007,1078.521,1217.906,1077.879Z",
    transform: "translate(-1178.109 -1055.701)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 158.022,
    cy: 55.943,
    rx: 158.022,
    ry: 55.943,
    transform: "translate(0 22.331)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1291.544 893.833)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 77.821,
    height: 77.821,
    rx: 12.45,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1657.269,1010.173V986.6l19.756,12.091Z",
    transform: "translate(-1628.237 -959.475)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1182.585 884.062)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1559.993,907.113c1.371-.942,3.533-.983,5.555-4.471,1.051-1.813,2.119-7.39.494-10.7-2.591-5.279-8.771-8.888-11.6-7.627-2.342,1.044,1.1,13.177,2.776,13.661S1559.993,907.113,1559.993,907.113Z",
    transform: "translate(-1452.941 -884.062)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M1492.921,981.842s-1.991,2.953-4.394,6.215c-2.57,3.489-4.161,4.651-6.749,4.686s-5.666,0-5.666,0l-.349,6.12,13.673,1.154,7.519-11.89Z",
    transform: "translate(-1403.079 -946.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1414.962,1066.541l-4.011,7.957,7.462.361,2.153-5.633Z",
    transform: "translate(-1361.587 -1000.883)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1443.459,1014.194c.921-1.254-9.522-18.546-13.5-20.962s-6.911.321-8.882,2.345-12.243,18.178-11.932,19.214,8.941,8.623,9.829,8.7,7.254-11.733,7.587-11.733,4.108,13.1,4.96,13.435S1442.791,1015.1,1443.459,1014.194Z",
    transform: "translate(-1360.426 -953.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1299.62,1091.165c-1.132-.277-5.989-2.441-7.6-4.077s-6.342,1.812-6.543,3.674,1.912,6.392,2.995,6.719,3.137.694,3.137.694l.773-.392a20.41,20.41,0,0,1,3.892-.221c1.866.111,3.969.668,4.066.613S1299.62,1091.165,1299.62,1091.165Z",
    transform: "translate(-1281.251 -1013.763)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M1385.74,1051.7c-1.857,1.415-4.57,6.486-5.926,7.076a35.1,35.1,0,0,1-11.537,2.745c-6.2.48-25.113,5.577-29.42,6.087s-14.863.367-15.2,1.033.229,9.375,1.146,9.625,23.245-1.136,25.386-1.388,26.165,1.259,29.912.773,19.027.146,21.606-1.168,4.915-4.087,5.256-5.693-3.309-10.073-6.131-12.02S1385.74,1051.7,1385.74,1051.7Z",
    transform: "translate(-1305.643 -991.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1433.23,1003.7c-.387-.893-.926-2.442-2.088-3.116a14.468,14.468,0,0,1-2.661-1.887c-.236-.3-.859-.185-1.28-.539s-1.078-.842-1.432-.2,2.207,3.133,1.617,3.1a3.012,3.012,0,0,1-1.651-.842c-.2-.269-.943-.674-1.348-.1a1.339,1.339,0,0,0,0,1.6c.3.4,1.882,2.776,1.578,2.607s-2.572-2.021-2.993-1.82-.842.893-.573,1.28-.021,2.691.273,3.037,1.59,1.054,1.918,1.452a10.167,10.167,0,0,0,5.168,1.3,8.968,8.968,0,0,0,3.163-.484C1433.526,1008.825,1433.23,1003.7,1433.23,1003.7Z",
    transform: "translate(-1368.862 -956.777)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1511.522,954.865c-2.051.7-5.92,6.1-6.663,8.534s-2.678,11.257-3.025,13.984-3.818,8.183-4.86,8.53-1.984.694-1.29,1.537,18.547,17.407,20.531,18.994,3.124,2.38,3.769,1.884,7.439-20.679,7.984-23.357,4.166-15.919,4.067-19.688-.248-5.9-2.728-7.736-5.356-6.2-6-6.844S1511.522,954.865,1511.522,954.865Z",
    transform: "translate(-1415.68 -926.687)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M1531.582,938.413a6.74,6.74,0,0,1,2.206,3.026,12.381,12.381,0,0,1,.847,4.691c-.167,1.4-2.262,4.133-1.871,3.965s6.981-3.742,9.188-4.915,5-2.4,4.887-3.435-1.005-3.407-1.005-4.664-3.63-1.7-5.837-1.145S1531.582,938.413,1531.582,938.413Z",
    transform: "translate(-1438.814 -917.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1531.285,901.9c-1.735,1.073-3.3,1.817-3.2,2.642s1.15,1.425.725,1.875-2.925,5.2-2.4,5.824,3.924,2.95,6.4,3.1,5.824-2.925,6.474-2.625,3.824.775,5.049-.55,1.648-2.555,1.35-3.375c-.207-.568-1.125-.725-2.15-.45a1.854,1.854,0,0,1-2.125-1.65,3.482,3.482,0,0,1,.933-2.346c1.263-1.475-4.344-7.81-6.059-7.406a7.518,7.518,0,0,0-4.383,2.578C1531.123,900.407,1531.922,901.5,1531.285,901.9Z",
    transform: "translate(-1435.458 -892.294)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1447.865,990.653c-.1,1.845-.031,4.456,1.184,4.674s12.308,2.524,15.455,3.241,12.309-.661,15.948-2.3,16-9.813,16.859-10.6c1.8-1.639,1.052-9.884-2.208-12.2s-9.247.35-11.844,3.014-8.835,12.2-12.13,12.688-11.8.4-13.827-.105-6.952-2.437-7.693-1.816A5.832,5.832,0,0,0,1447.865,990.653Z",
    transform: "translate(-1385.198 -940.735)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M1432.27,1004.225c-.163-.257.393-.566.781-.592s.927,1.091.845,1.232c-.109.188-.776.077-1.174-.167A.9.9,0,0,1,1432.27,1004.225Z",
    transform: "translate(-1375.217 -960.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M1425.553,1008.05c-.366-.121-1,.555-1.119.83s.257.778.473.987,1.341,1.462,1.678,1.462.863-.2.863-.664A7.913,7.913,0,0,0,1425.553,1008.05Z",
    transform: "translate(-1370.204 -963.429)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M1422.6,1016.278a1.086,1.086,0,0,0-.581,1.132c.341.8,2.176,1.546,2.59,1.724s1.191.5,1.448.118-.355-1.3-.886-1.585-.986-.522-1.109-.8A1.325,1.325,0,0,0,1422.6,1016.278Z",
    transform: "translate(-1368.653 -968.681)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1425.156,1024.039c-.468.124-.4.929-.239,1.076a6.372,6.372,0,0,0,1.812,1.067,4.161,4.161,0,0,0,1.582.055c.209-.135.156-.793-.156-1.068s-1.5-.4-1.858-.624S1425.607,1023.919,1425.156,1024.039Z",
    transform: "translate(-1370.452 -973.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M1283.249,1067.166c-1.329,1.017-2.428,2.313-3.133,2.247s-1.23-.148-1.23.36,2.73,6.134,4.1,6.51,1.906,0,1.906,0-.471,1.13-3.507.965-4.072-1.012-4.472-1.953-1.318-6-2.142-7.626-1.695-8.967-.188-11.392,2.307-3.224,3.177-3.2,1.742.023,1.977,1.012,5.272,10.591,5.154,11.25S1283.249,1067.166,1283.249,1067.166Z",
    transform: "translate(-1273.756 -992.264)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.8c252085437fdf96057a0566f4d28b49.svg";
export { ForwardRef as ReactComponent };